



































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SecaoTabela extends Vue {
	@Prop({ type: String, default: '' }) titulo!: string
	@Prop({ type: String, default: 'mdi-table' }) icone!: string
	@Prop({ type: Array, default: () => [] }) headers!: any[]
	@Prop({ type: Array, default: () => [] }) items!: any[]
	@Prop({ type: Boolean, default: false }) loading!: boolean
	@Prop({ type: String, default: '' }) atualizadoEm!: string
	// Mapa coluna -> valor já formatado da linha de totalizadores. Se vazio/nulo, a linha não aparece.
	@Prop({ type: Object, default: null }) totais!: Record<string, string> | null

	get temTotais(): boolean {
		return !!this.totais && !!this.items.length
	}
}
